import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

export default function PoliticaPrivacidade() {
  return (
    <div className="legal-container">
      <div className="legal-header">
        <h1>🔒 Política de Privacidade</h1>
        <p className="subtitle">Canal de Ética, Integridade e Ouvidoria - Grupo Vilarouca</p>
      </div>

      <div className="legal-content">
        <section className="legal-section">
          <h2>1. Dados Que Coletamos</h2>

          <h3>📝 Denúncia Anônima</h3>
          <ul>
            <li><strong>Tipo:</strong> denuncia, reclamação, sugestão, elogio</li>
            <li><strong>Categoria:</strong> Assédio Moral, Corrupção, Fraude, etc</li>
            <li><strong>Descrição:</strong> Seu relato dos fatos</li>
            <li><strong>Data do Fato:</strong> Quando ocorreu a situação</li>
            <li><strong>Unidade:</strong> Qual loja/filial se relaciona</li>
            <li><strong>Evidências:</strong> Arquivos anexados (fotos, vídeos, documentos)</li>
            <li><strong>Protocolo e PIN:</strong> Para acompanhamento seguro</li>
          </ul>

          <div className="alert alert-info">
            <strong>✅ Importante:</strong> Denúncias anônimas NÃO coletam:
            <ul style={{marginTop: '10px'}}>
              <li>Seu endereço IP</li>
              <li>Localização</li>
              <li>Cookies ou rastreamento</li>
              <li>User-Agent ou navegador</li>
              <li>Qualquer identificador persistente</li>
            </ul>
          </div>

          <h3>📋 Denúncia Identificada</h3>
          <p>Além dos dados acima, coletamos:</p>
          <ul>
            <li><strong>Nome completo</strong> (criptografado)</li>
            <li><strong>Email</strong> (criptografado)</li>
            <li><strong>Telefone</strong> (criptografado)</li>
            <li><strong>Relação com Grupo Vilarouca</strong> (Colaborador, Fornecedor, Cliente)</li>
            <li><strong>Cargo/Função</strong></li>
          </ul>

          <div className="alert alert-warning">
            <strong>⚠️ Sua Privacidade:</strong> Dados identificados são SEPARADOS dos dados da denúncia e protegidos com criptografia AES-256. Apenas pessoas autorizadas (RH, Jurídico, seu investigador) têm acesso.
          </div>
        </section>

        <section className="legal-section">
          <h2>2. Para Quê Usamos Seus Dados</h2>
          <ul>
            <li><strong>Exclusivamente</strong> para investigação de ética e compliance</li>
            <li>Para tomar medidas corretivas se houver irregularidades</li>
            <li>Para manter registro de conformidade legal</li>
            <li>Para comunicação sobre sua denúncia (anônima ou identificada)</li>
          </ul>

          <div className="alert alert-success">
            <strong>❌ O que NÃO fazemos:</strong>
            <ul style={{marginTop: '10px'}}>
              <li>Não compartilhamos com terceiros</li>
              <li>Não usamos para marketing ou análise comportamental</li>
              <li>Não criamos perfis ou monitoramos você</li>
              <li>Não repassamos para agências externas</li>
            </ul>
          </div>
        </section>

        <section className="legal-section">
          <h2>3. Quanto Tempo Guardamos</h2>
          <table className="retention-table">
            <thead>
              <tr>
                <th>Tipo de Dado</th>
                <th>Período Ativo</th>
                <th>Arquivo</th>
                <th>Exclusão</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Denúncia</td>
                <td>Até conclusão</td>
                <td>2 anos</td>
                <td>Deletado permanentemente</td>
              </tr>
              <tr>
                <td>Identidade (identificadas)</td>
                <td>Até conclusão</td>
                <td>2 anos</td>
                <td>Deletado permanentemente</td>
              </tr>
              <tr>
                <td>Evidências (arquivos)</td>
                <td>Até conclusão</td>
                <td>Conforme legal</td>
                <td>Deletado ou anonimizado</td>
              </tr>
              <tr>
                <td>Parecer/Conclusão</td>
                <td>N/A</td>
                <td>2 anos</td>
                <td>Anonimizado</td>
              </tr>
              <tr>
                <td>Log de Acesso (auditoria)</td>
                <td>Sempre</td>
                <td>2 anos</td>
                <td>Anonimizado</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section className="legal-section">
          <h2>4. Como Protegemos</h2>
          <div className="protection-grid">
            <div className="protection-item">
              <span className="icon">🔐</span>
              <strong>Criptografia AES-256-GCM</strong>
              <p>Dados sensíveis criptografados em repouso e em trânsito</p>
            </div>
            <div className="protection-item">
              <span className="icon">📋</span>
              <strong>Auditoria Imutável</strong>
              <p>Todos acessos registrados e ninguém pode apagar logs</p>
            </div>
            <div className="protection-item">
              <span className="icon">🔑</span>
              <strong>Controle de Acesso</strong>
              <p>RBAC: apenas pessoas autorizadas veem dados</p>
            </div>
            <div className="protection-item">
              <span className="icon">⚠️</span>
              <strong>Validação</strong>
              <p>Proteção contra SQL Injection, XSS e outras ameaças</p>
            </div>
          </div>
        </section>

        <section className="legal-section">
          <h2>5. Seus Direitos (LGPD)</h2>
          <div className="rights-list">
            <div className="right-item">
              <h3>✅ Direito de Acesso</h3>
              <p>Você pode acessar todos seus dados usando Protocolo + PIN</p>
            </div>
            <div className="right-item">
              <h3>✏️ Direito de Correção</h3>
              <p>Se os dados estiverem errados, solicite correção (denúncias identificadas)</p>
            </div>
            <div className="right-item">
              <h3>🗑️ Direito de Exclusão</h3>
              <p>Após período de retenção, seus dados são deletados permanentemente</p>
            </div>
            <div className="right-item">
              <h3>📤 Direito de Portabilidade</h3>
              <p>Solicite seus dados em formato JSON ou XML</p>
            </div>
          </div>
        </section>

        <section className="legal-section">
          <h2>6. Contato - Proteção de Dados</h2>
          <div className="contact-box">
            <p><strong>Data Protection Officer (DPO)</strong></p>
            <p>Email: <a href="mailto:dpo@grupovilarouca.com.br">dpo@grupovilarouca.com.br</a></p>
            <p>Telefone: [A definir]</p>
            <p style={{marginTop: '20px', fontSize: '0.9em'}}>
              Se tiver dúvidas sobre seus dados ou direitos LGPD, nosso DPO está à disposição.
            </p>
          </div>
        </section>

        <section className="legal-section">
          <h2>7. Alterações nesta Política</h2>
          <p>
            Esta Política de Privacidade pode ser atualizada periodicamente.
            Atualizações significativas serão comunicadas por email (para denúncias identificadas)
            ou publicadas nesta página.
          </p>
          <p><strong>Última atualização:</strong> 16 de Setembro de 2026</p>
        </section>

        <div className="legal-footer">
          <p>Ao usar o Canal de Ética, você concorda com esta Política de Privacidade.</p>
          <p>📖 Leia também nossos <Link to="/termos">Termos de Uso</Link></p>
        </div>
      </div>

      <div className="legal-back">
        <Link to="/" className="btn-back">← Voltar ao Canal de Ética</Link>
      </div>
    </div>
  );
}
